import BasicDatagrid from '../../../components/shared/tables/BasicDatagrid'
import { styled } from '@mui/material'
const TableGestao = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '20vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '20vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '20vh'
  },
  '& .MuiDataGrid-cell': {
    textAlign: 'start'
  },

  '& .MuiDataGrid-columnHeaderTitleContainer': {
    width: '100%'
  },
  '& .MuiDataGrid-columnHeaderTitleContainerContent': {
    width: '100%!important'
  },

  '& .MuiDataGrid-columnHeader:first-of-type .MuiDataGrid-columnHeaderTitle': {
    textAlign: 'left'
  },
  '& .MuiDataGrid-columnHeader:last-of-type .MuiDataGrid-columnHeaderTitle': {
    textAlign: 'left'
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    textAlign: 'center',
    width: '100%'
  },
  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
    background: 'transparent'
  },
  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-button': {
    backgroundColor: '#ddd'
  },
  '& .MuiDataGrid-virtualScroller::-webkit-arrow-color': {
    color: 'red'
  },
  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
    background: 'transparent'
  },
  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
    backgroundColor: 'transparent'
  }
}))

export default TableGestao
